import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Determina il basename in base all'URL in cui ci troviamo
// Così funziona sia in localhost (/) che sul sito di produzione (/PrenotaSpazi)
const getBasename = () => {
  if (window.location.pathname.startsWith('/PrenotaSpazi')) {
    return '/PrenotaSpazi';
  }
  return '';
};

root.render(
  <React.StrictMode>
    <BrowserRouter basename={getBasename()}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
